import React, { useEffect, useState } from "react";
import { API_BASE_URL, apiRoutes } from "../../constants";
import _ from "lodash";
import Axios from "axios";
import {
  getSessionStorageString,
  setSessionStorageString,
  removeFromStorage,
} from "../../helpers/utils";
import DISPLAY_TEXTS from "../../helpers/displayTexts";

export const selfRegistrationTokenKey = "SELF_VALIDITY_TOKEN";

const useInviteValidity = () => {
  const [token, setToken] = useState(null);
  const [isValidated, setIsValidated] = useState(null);
  const [errorMessageList, setErrorMessageList] = useState([]);

  const checkTokenValidity = async () => {
    if (token === null) return;
    if (_.isEmpty(token)) {
      handleValidate(false);
      setSessionStorageString(selfRegistrationValidity, "false");
      return;
    }
    const url = new URL(
      `${API_BASE_URL}${apiRoutes.publicRegisterInviteValidate}${token}`
    );
    Axios.post(url)
      .then(() => {
        handleValidate(true);
      })
      .catch((error) => {
        handleValidate(false);
        setErrorMessageList(
          error?.response?.data?.errors ?? [
            DISPLAY_TEXTS.PUBLIC_INVITE_INVALID_LINK,
          ]
        );
      });
  };

  const handleValidate = (validated) => {
    setIsValidated(validated);
  };

  const handleResetValidityFromSession = () => {
    removeFromStorage(selfRegistrationTokenKey);
  };

  useEffect(() => {
    const tokenFromURL = window.location.hash.split("?")?.[1];
    if (_.isEmpty(tokenFromURL)) {
      const tokenFromSessionStorage = getSessionStorageString(
        selfRegistrationTokenKey
      );
      setToken(tokenFromSessionStorage ?? "");
    } else {
      setSessionStorageString(selfRegistrationTokenKey, tokenFromURL);
      handleResetValidityFromSession();
      setToken(tokenFromURL ?? "");
      location.replace(window.location.toString()?.split("?")[0]);
    }
  }, []);

  useEffect(() => {
    checkTokenValidity();
  }, [token]);

  return {
    isValidated,
    errorMessageList,
  };
};

export default useInviteValidity;
